export var reports = function reports(centralApi, getToken) {
  return {
    getDailyUrl: function getDailyUrl(id) {
      return centralApi.buildUrl('/report/mobile-device/daily', {
        inmateId: id,
        token: getToken().accessToken
      });
    }
  };
};